var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "payment-monitor" },
    [
      !_vm.evidence
        ? _c("el-alert", {
            attrs: {
              title: _vm.refreshFailed
                ? "监控刷新失败，当前状态未知"
                : "监控证据未知：订单与支付组不匹配或后台未提供监控数据",
              type: "warning",
              closable: false,
              "show-icon": "",
            },
          })
        : [
            _c("div", { staticClass: "monitor-note" }, [
              _vm._v("详情打开时约每 60 秒刷新；以后台观察和查询时间为准。"),
            ]),
            _vm.wechat.freshnessState === "STALE"
              ? _c("el-alert", {
                  attrs: {
                    title: "微信观察证据已过期，以下状态不代表当前渠道状态",
                    type: "warning",
                    closable: false,
                    "show-icon": "",
                  },
                })
              : _vm._e(),
            _c(
              "el-descriptions",
              {
                staticClass: "monitor-section",
                attrs: {
                  title: "微信原支付单（整组）",
                  column: 2,
                  size: "small",
                  border: "",
                },
              },
              [
                _c("el-descriptions-item", { attrs: { label: "订单状态" } }, [
                  _vm._v(_vm._s(_vm.wechatOrderText(_vm.wechat))),
                ]),
                _c("el-descriptions-item", { attrs: { label: "确认收货" } }, [
                  _vm._v(_vm._s(_vm.receiptText(_vm.wechat))),
                ]),
                _c(
                  "el-descriptions-item",
                  { attrs: { label: "确认方式 / 时间" } },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.confirmMethodText(_vm.wechat.confirmReceiveMethod)
                      ) +
                        " / " +
                        _vm._s(_vm.wechat.confirmReceiveTime || "-")
                    ),
                  ]
                ),
                _c("el-descriptions-item", { attrs: { label: "实际结算" } }, [
                  _vm._v(_vm._s(_vm.settlementText(_vm.wechat))),
                ]),
                _c("el-descriptions-item", { attrs: { label: "冻结状态" } }, [
                  _vm._v("未知（未提供独立冻结凭证）"),
                ]),
                _c("el-descriptions-item", { attrs: { label: "结算时间" } }, [
                  _vm._v(
                    _vm._s(
                      _vm.settlementText(_vm.wechat) ===
                        "已结算（微信验签推送）"
                        ? _vm.wechat.settlementTime
                        : "-"
                    )
                  ),
                ]),
                _c(
                  "el-descriptions-item",
                  { attrs: { label: "观察来源 / 时间" } },
                  [
                    _vm._v(
                      _vm._s(_vm.wechat.observationSource || "NONE") +
                        " / " +
                        _vm._s(_vm.wechat.observedAt || "-")
                    ),
                  ]
                ),
                _c("el-descriptions-item", { attrs: { label: "证据时效" } }, [
                  _vm._v(_vm._s(_vm.wechat.freshnessState || "UNKNOWN")),
                ]),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "monitor-section" },
              [
                _c("div", { staticClass: "monitor-title" }, [
                  _vm._v(
                    "计全付逐商品单位分账（本地计划及已核对查询；更新 " +
                      _vm._s(_vm.jeequan.statusUpdatedAt || "-") +
                      "）"
                  ),
                ]),
                !_vm.units.length
                  ? _c("el-empty", {
                      attrs: { description: "暂无逐单位分账证据" },
                    })
                  : _c(
                      "el-table",
                      { attrs: { data: _vm.units, size: "small", border: "" } },
                      [
                        _c("el-table-column", {
                          attrs: { label: "商品子单", "min-width": "155" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    _vm._s(scope.row.itemSubOrderNo || "未知")
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: { label: "商城单位收货", "min-width": "120" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    _vm._s(_vm.mallReceiptText(scope.row))
                                  ),
                                  scope.row.mallReceiptState === "RECEIVED"
                                    ? _c("span", [
                                        _vm._v(
                                          " / " +
                                            _vm._s(
                                              scope.row.mallReceivedAt ||
                                                "时间未知"
                                            )
                                        ),
                                      ])
                                    : _vm._e(),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: { label: "单位分账", "min-width": "100" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    _vm._s(_vm.unitDivisionText(scope.row))
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: { label: "执行意图", "min-width": "100" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    _vm._s(scope.row.intentStatus || "UNKNOWN")
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: { label: "等待原因", "min-width": "130" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(_vm._s(scope.row.waitReason || "-")),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: "计划来源 / 状态 / 更新时间 / 上次查询",
                            "min-width": "280",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._l(
                                    scope.row.plans || [],
                                    function (plan, index) {
                                      return _c("div", { key: index }, [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              plan.evidenceSource || "UNKNOWN"
                                            ) +
                                            " / " +
                                            _vm._s(_vm.planText(plan)) +
                                            " / " +
                                            _vm._s(
                                              plan.statusUpdatedAt || "-"
                                            ) +
                                            " / " +
                                            _vm._s(plan.lastQueryAt || "未查询")
                                        ),
                                        plan.queryError
                                          ? _c("span", [
                                              _vm._v(
                                                "（当前状态待核验：" +
                                                  _vm._s(plan.queryError) +
                                                  "）"
                                              ),
                                            ])
                                          : _vm._e(),
                                      ])
                                    }
                                  ),
                                  !scope.row.plans || !scope.row.plans.length
                                    ? _c("span", [_vm._v("无计划证据")])
                                    : _vm._e(),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
              ],
              1
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }